/* src/components/user-identity-input/user-identity-input.component.scss */
.option {
  display: flex;
  width: 100%;
  flex: 1;
  min-height: 1.8rem;
  justify-content: space-between;
  align-items: center;
}
.option--vertical {
  flex-direction: column;
  align-items: flex-start;
}
.text-light {
  display: block;
  font-weight: var(--vwui-font-weight-semibold);
  color: var(--vwui-color-neutral-1);
}
/*# sourceMappingURL=user-identity-input.component-JYYFH7FW.css.map */
